import { useContext, useState } from 'react'
import { AppContext, AppContextType } from '../../AppContext'
import { isDefinedDeviceId } from '../../Logic'
import { UserContext, UserContextType } from '../../UserContext'
import AudioComponent from '../../pages/CollaboratePage/Audio'
import { env } from '../../services/EnvironmentVariables'
import * as Constants from '../../services/Constants'
import ElectronIPC from '../../services/ElectronIPC'
import { useNonIdempotentEffect } from '@/hooks/useNonIdempotentEffect'

export default function AppNotificationSound() {
    const { state: appState } = useContext(AppContext) as AppContextType
    const { state } = useContext(UserContext) as UserContextType

    const [playSound, set_playSound] = useState(0)

    const src = Constants.appNotificationChimeSrc

    useNonIdempotentEffect(() => {
        const appNotification = appState.appState.appNotification
        if (!appNotification) {
            return
        }

        console.log(`AppNotificationSound: added=${JSON.stringify(appNotification)}`)
        if (env.IS_ELECTRON) {
            if (!appNotification.audioOnly) {
                if (!appNotification.body) {
                    appNotification.body = ' ' // need at least something, otherwise notification does not show (macos)
                }
                ElectronIPC.showNotification(appNotification)
            } else {
                set_playSound((c) => c + 1)
            }
        } else {
            // just emit sound for now.
            if (!appNotification.muteAudioIfPossible) {
                set_playSound((c) => c + 1)
            }
        }
    }, [appState.appState.appNotification])

    return (
        <>
            {!!playSound && (
                <AudioComponent
                    key={playSound}
                    src={src}
                    sinkId={
                        isDefinedDeviceId(state.mediaSelection.audioOutput)
                            ? state.mediaSelection.audioOutput
                            : 'default'
                    }
                    onEnded={() => set_playSound(0)}
                    autoPlay
                />
            )}
        </>
    )
}
